(() => {
  const populateLookbookFromTemplates = (wrapper, modal) => {
    const list = modal.querySelector('.hotspot-lookbook__slider ul.slider');
    const trigger = wrapper.querySelector('[data-hotspot-lookbook-open]');
    if (!list) return;

    // Sections render their lookbook items server-side already; only theme
    // blocks (which can't see sibling blocks' settings in Liquid) rely on
    // these hidden templates.
    if (list.children.length > 0) return;

    const templates = wrapper.querySelectorAll('template.hotspot-lookbook-item');
    let count = 0;

    templates.forEach((template) => {
      count += 1;

      const item = template.content.firstElementChild.cloneNode(true);
      item.id = `Slide-lookbook-${wrapper.dataset.hotspotBannerId}-${count}`;
      list.appendChild(item);
    });

    list.style.setProperty('--lookbook-max', count);
    if (trigger) trigger.hidden = count === 0;
  };

  const initLookbookModal = (wrapper) => {
    const uniqueId = wrapper.dataset.hotspotBannerId;
    const openButton = wrapper.querySelector(`[data-hotspot-lookbook-open="${uniqueId}"]`);
    const modal = document.getElementById(`hotspot-lookbook-modal-${uniqueId}`);
    if (!modal) return;

    populateLookbookFromTemplates(wrapper, modal);

    if (!openButton) return;

    const slider = modal.querySelector('.hotspot-lookbook__slider ul.slider');
    const sliderHost = modal.querySelector('.hotspot-lookbook__slider');
    const prevBtn = modal.querySelector('.hotspot-lookbook__slider .slider-button--prev');
    const nextBtn = modal.querySelector('.hotspot-lookbook__slider .slider-button--next');
    const content = modal.querySelector('.hotspot-lookbook__modal-content');
    const closeTargets = modal.querySelectorAll(`[data-hotspot-lookbook-close="${uniqueId}"]`);
    const edgeTol = () => Math.max(8, Number.parseFloat(getComputedStyle(slider).gap || 0) || 0);
    const maxLeft = () => Math.max(0, Math.round(slider.scrollWidth - slider.clientWidth));

    const syncVariantFormState = (form) => {
      if (!form) return;

      const selectedVariantInput = form.querySelector('input[name="id"]:checked');
      if (!selectedVariantInput) return;

      const submitButton = form.querySelector('.quick-add__submit');
      const addToCartLabel = submitButton?.querySelector('.label:not(.sold-out-message)');
      const soldOutLabel = submitButton?.querySelector('.sold-out-message');
      const isSoldOut = selectedVariantInput.disabled;

      if (!submitButton || !addToCartLabel || !soldOutLabel) return;

      submitButton.toggleAttribute('disabled', !!isSoldOut);
      addToCartLabel.classList.toggle('hidden', !!isSoldOut);
      soldOutLabel.classList.toggle('hidden', !isSoldOut);
    };

    modal.querySelectorAll('.hotspot-lookbook-product-form form').forEach((form) => {
      const variantInputs = form.querySelectorAll('input[type="radio"][name="id"]');
      if (!variantInputs.length) return;

      variantInputs.forEach((input) => {
        input.addEventListener('change', () => syncVariantFormState(form));
      });
      syncVariantFormState(form);
    });

    const syncSliderState = () => {
      if (!slider || !sliderHost) return;
      const tol = Math.max(6, edgeTol() + 2);
      const overflow = slider.scrollWidth - slider.clientWidth > tol;
      slider.classList.toggle('no-overflow', !overflow);
      sliderHost.classList.toggle('no-overflow', !overflow);
      if (!overflow) slider.scrollLeft = 0;

      const left = Math.round(slider.scrollLeft);
      const max = maxLeft();
      if (prevBtn) prevBtn.toggleAttribute('disabled', left <= edgeTol());
      if (nextBtn) nextBtn.toggleAttribute('disabled', max - left <= edgeTol());
    };

    const scrollByButton = (direction) => {
      const left = Math.round(slider.scrollLeft);
      const max = maxLeft();
      const tol = edgeTol();

      if ((direction === 'next' && max - left <= tol) || (direction === 'previous' && left <= tol)) {
        syncSliderState();
        return;
      }

      const offsets = [...slider.querySelectorAll('.slider__slide')]
        .map((el) => Math.round(el.offsetLeft))
        .filter((x, i, arr) => i === 0 || x !== arr[i - 1]);
      if (!offsets.length || offsets[offsets.length - 1] !== max) offsets.push(max);

      const target =
        direction === 'next'
          ? offsets.find((x) => x > left + 2) ?? max
          : [...offsets].reverse().find((x) => x < left - 2) ?? 0;

      slider.scrollTo({ left: target, behavior: 'smooth' });
    };

    const openModal = () => {
      modal.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hotspot-lookbook--isActive');
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        content?.focus();
        syncSliderState();
        setTimeout(syncSliderState, 60);
      });
    };

    const closeModal = () => {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hotspot-lookbook--isActive');
      document.body.classList.remove('overflow-hidden');
      window.setTimeout(() => {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 450);
    };

    openButton.addEventListener('click', openModal);
    closeTargets.forEach((target) => target.addEventListener('click', closeModal));
    window.addEventListener('resize', () => requestAnimationFrame(syncSliderState));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (slider) {
      [prevBtn, nextBtn].forEach((btn) => {
        btn?.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            scrollByButton(btn.name === 'next' ? 'next' : 'previous');
          },
          true
        );
      });

      slider.addEventListener('scroll', syncSliderState, { passive: true });
      syncSliderState();
    }
  };

  const initHotspotMediaBanner = (wrapper) => {
    if (wrapper.dataset.hotspotBannerInitialized) return;
    wrapper.dataset.hotspotBannerInitialized = 'true';
    initLookbookModal(wrapper);
  };

  const init = () => {
    document.querySelectorAll('.hotspot-media-banner').forEach(initHotspotMediaBanner);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
